// Turns a builder template into the HTML document stored in custom_invoice.html.
//
// The stored page carries the print runtime and the template. At print time
// the backend appends a script that sets `window.__ZP_DATA__` and calls
// `window.__ZP_RENDER__()`, then closes </body></html>. Runtime and template
// are base64 encoded because the backend strips newlines and repeated spaces
// from print HTML.
import { zpRuntime } from "./runtime/zp-runtime";

export const ZP = zpRuntime();
const RUNTIME_SOURCE = zpRuntime.toString();

function b64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}

function esc(s) {
  return String(s || "").replace(/[<>&"]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c]));
}

const BOOT =
  "(function(){try{" +
  "var d=function(s){return decodeURIComponent(escape(atob(s)));};" +
  'window.__ZP__=(new Function("return ("+d(window.__ZP_RT__)+")();"))();' +
  "window.__ZP_TEMPLATE__=JSON.parse(d(window.__ZP_TPL__));" +
  "var done=false;" +
  "window.__ZP_RENDER__=function(){if(!window.__ZP_DATA__)return;done=true;window.__ZP__.mount(window.__ZP_TEMPLATE__,window.__ZP_DATA__,document);};" +
  'document.addEventListener("DOMContentLoaded",function(){if(!done)window.__ZP_RENDER__();});' +
  '}catch(e){document.body.innerHTML="<pre>Print template error: "+e.message+"</pre>";}})();';

export function compileTemplateHtml(template) {
  const css = ZP.baseCss() + ZP.pageCss(template);
  return (
    '<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="zp-builder" content="1">' +
    "<title>" + esc(template.name) + "</title>" +
    "<style>" + css + "</style></head><body>" +
    '<div id="zp-mount"></div>' +
    '<script>window.__ZP_RT__="' + b64(RUNTIME_SOURCE) + '";window.__ZP_TPL__="' + b64(JSON.stringify(template)) + '";</script>' +
    "<script>" + BOOT + "</script>"
  );
}

// The same script the backend appends, used for previews and test prints.
export function dataScript(data) {
  return (
    '<script>window.__ZP_DATA__=JSON.parse(decodeURIComponent(escape(atob("' + b64(JSON.stringify(data)) + '"))));' +
    "window.__ZP_RENDER__&&window.__ZP_RENDER__();</script>"
  );
}

export function previewHtml(template, data) {
  return compileTemplateHtml(template) + dataScript(data) + "</body></html>";
}
